(function(){
  var header=document.querySelector('.site-header');
  if(header){window.addEventListener('scroll',function(){header.classList.toggle('is-stuck',window.scrollY>10);},{passive:true});}
  var burger=document.querySelector('[data-drawer-open]');
  var drawer=document.getElementById('MobileDrawer');
  var overlay=document.querySelector('.drawer-overlay');
  function close(){drawer&&drawer.classList.remove('open');overlay&&overlay.classList.remove('open');}
  if(burger&&drawer){burger.addEventListener('click',function(){drawer.classList.add('open');overlay.classList.add('open');});}
  if(overlay){overlay.addEventListener('click',close);}
  var closer=document.querySelector('[data-drawer-close]');
  if(closer){closer.addEventListener('click',close);}
})();
